(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oe-product"] && !Shopify.designMode) return;
  try {
    
let oePilotPending = false;
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const section = form.closest('.oe-product-page');
  if (!section || !form.querySelector('input[name="id"]')) return;
  if (event.submitter && event.submitter.name !== 'add') return;
  event.preventDefault();
  if (oePilotPending) return;
  oePilotPending = true;
  const buttons = [...section.querySelectorAll('button[name="add"]:not([disabled])')];
  for (const button of buttons) button.disabled = true;
  const oldError = section.querySelector('.oe-purchase-error');
  if (oldError) oldError.remove();
  try {
    const root = section.dataset.cartRoot || '/';
    const current = await fetch(root + 'cart.js', { headers: { Accept:'application/json' } });
    if (!current.ok) throw new Error('cart');
    const cart = await current.json();
    const variant = Number(new FormData(form).get('id'));
    if (!cart.items.some(item => item.variant_id === variant)) {
      const payload = new FormData(form);
      payload.set('quantity', '1');
      const added = await fetch(root + 'cart/add.js', {method:'POST',body:payload,headers:{Accept:'application/json'}});
      if (!added.ok) throw new Error('add');
    }
    window.location.assign(section.dataset.cartUrl);
  } catch {
    const error = document.createElement('p');
    error.className = 'oe-purchase-error';
    error.setAttribute('role','alert');
    error.textContent = section.dataset.addError;
    form.append(error);
    oePilotPending = false;
    for (const button of buttons) button.disabled = false;
  }
});
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  oePilotPending = false;
  for (const button of document.querySelectorAll('.oe-product-page button[name="add"]')) {
    if (button.dataset.available === 'true') button.disabled = false;
  }
});

  } catch(e) { console.error(e); }
})();
})();
